import React from "react"
import {useAppSelector} from "../../store/store";

import LicenseCode from "./components/LicenseCode";
import LicenseFile from "./components/LicenseFile";
import LicenseValidation from "./components/LicenseValidation";
import LicenseActivation from "./components/LicenseActivation";

const LicenseActivate = () => {
    const stepIncrease = useAppSelector((state) => state.license.stepIncrease)
    const stepItems = ["Lisans Kodu", "Dosya Seçimi", "Doğrulama", "Aktivasyon"]

    return (
        <div className="max-w-2xl mx-auto mt-4 px-4 md:px-0">
            <ul aria-label="Steps" className="items-center text-gray-600 dark:text-gray-300 font-medium md:flex">
                {stepItems.map((item, idx) => (
                    <li key={idx} aria-current={stepIncrease === idx + 1 ? "step" : false}
                        className="flex-1 last:flex-none flex md:items-center">
                        <div className="flex gap-x-3">
                            <div className="flex items-center flex-col gap-x-2">
                                <div
                                    className={`w-8 h-8 rounded-full border-2 flex-none flex items-center justify-center ${stepIncrease > idx + 1 || stepIncrease === 4 ? "bg-indigo-600 border-indigo-600" : "" || stepIncrease === idx + 1 ? "border-indigo-600 dark:border-indigo-300" : ""}`}>
                                    <span
                                        className={` ${stepIncrease > idx + 1 || stepIncrease === 4 ? "hidden" : "" || stepIncrease === idx + 1 ? "text-indigo-600 dark:text-indigo-300" : ""}`}>
                                        {idx + 1}
                                    </span>
                                    {
                                        stepIncrease > idx + 1 || stepIncrease === 4 ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-white">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M4.5 12.75l6 6 9-13.5"/>
                                            </svg>
                                        ) : ""
                                    }
                                </div>
                                <div
                                    className={`h-12 flex items-center md:hidden ${idx + 1 === stepItems.length || stepIncrease === 4 ? "hidden" : ""}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                                    </svg>
                                </div>
                            </div>
                            <div className="h-8 flex items-center md:h-auto">
                                <h3 className={`text-sm ${stepIncrease === idx + 1 ? "text-indigo-600 dark:text-indigo-300" : ""}`}>
                                    {item}
                                </h3>
                            </div>
                        </div>
                        <div
                            className={`flex-1 hidden md:block ${idx + 1 === stepItems.length ? "md:hidden" : ""}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                                 stroke="currentColor" className="w-5 h-5 mx-auto text-gray-500">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
                            </svg>
                        </div>
                    </li>
                ))}
            </ul>
            <div>
                {
                    stepIncrease === 1 ?
                        <LicenseCode/>
                        : stepIncrease === 2 ?
                            <LicenseFile/>
                            : stepIncrease === 3 ?
                                <LicenseValidation/>
                                : <LicenseActivation/>
                }
            </div>
        </div>
    )
}
export default LicenseActivate